<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-form @submit.prevent="geraRelatorio()">
                  <FiltroNotasFiscais :tipo="tipo" :filtro="filtro"/>
                </b-form>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div v-show="httpSend" role="alert" aria-live="polite" aria-atomic="true"
                     class="alert alert-primary text-center">
                  Gerando Relatório
                  <br><i class="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i> Aguarde
                </div>
                <div v-show="reposta.status === true" role="alert" aria-live="polite"
                     aria-atomic="true"
                     class="alert alert-success">
                  Relatório gerado com sucesso
                  <br><a v-bind:href="relLink" target="_blank" class="alert-link"><i class="mdi mdi-download mr-2"></i>
                  Clique
                  aqui para baixar o
                  relatório </a>
                </div>
                <div v-show="reposta.status === false" role="alert" aria-live="polite" aria-atomic="true"
                     class="alert alert-danger">
                  <i class="mdi mdi-alert mr-2"></i> Não foi possível gerar o relatório.
                  <br> {{ reposta.mensagem }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import FiltroNotasFiscais from '@/router/views/contribuinte/relatorios/components/filtro-notas-fiscais.vue'
import PageHeader from "@/components/page-header";
import {openRelatorioJava, relDuams} from "@/api/relatorio_java/relatorios";
import moment from "moment/moment";

export default {
  page: {
    title: "Relatório de DUAMs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    FiltroNotasFiscais
  },
  props: {
    tipo: {
      type: String
    },
  },
  data() {
    return {
      title: "Relatório de DUAMs",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Relatório de DUAMs',
          active: true,
        },
      ],
      httpSend: false,
      relLink:'',
      filtro: {
        eco_codigo: null,
        not_emissao_ano: "",
        sep_competencia_inicial: "",
        sep_competencia_final: "",
        not_emissao_incial: "",
        not_emissao_final: "",
        sep_exigibilidade_iss: "",
        not_cancelada: "",
        sep_municipio_incidencia:"",
        sep_iss_retido: "",
        sep_cpf_cnpj_tomador: "",
        sep_razao_social_tomador: "",
        tipo_avulsa: "1",
        tab_106situacao: "",
        dam_vencimento_inicial:moment().startOf('year').format('YYYY-MM-DD'),
        dam_vencimento_final:moment().endOf('year').format('YYYY-MM-DD'),
      },
      reposta: {
        status: null,
        mensagem: '',
      }
    };
  },
  computed: {},
  methods: {
    geraRelatorio() {
      this.reposta.status = null;
      this.httpSend = true;
      relDuams(this.filtro).then(result => {
        const rs = result.response;
        if (rs.status) {
          this.reposta.status = true;
          this.relLink = openRelatorioJava(rs.data, "Relatório de DUAMs");
        } else {
          this.reposta.status = false;
          this.reposta.mensagem = rs.mensage;
        }
      }).catch(error => {
        this.reposta.status = false;
        this.reposta.mensagem = error;
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>


